"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GelatoConversionRateRequestError = exports.GelatoEstimatedFeeRequestError = void 0;
const error_1 = require("../types/error");
class GelatoEstimatedFeeRequestError extends error_1.NxtpError {
    constructor(chainId, context = {}) {
        super(`Error with API request for Gelato fee estimate`, {
            ...context,
            chainId,
        });
        this.context = context;
    }
}
exports.GelatoEstimatedFeeRequestError = GelatoEstimatedFeeRequestError;
class GelatoConversionRateRequestError extends error_1.NxtpError {
    constructor(chainId, context = {}) {
        super(`Error with API request for Gelato conversion rate`, {
            ...context,
            chainId,
        });
        this.context = context;
    }
}
exports.GelatoConversionRateRequestError = GelatoConversionRateRequestError;
//# sourceMappingURL=errors.js.map